import React from 'react';
import { useTranslation } from 'react-i18next';
import SVGImage from '../layout/SVGImage';
// import { format } from 'date-fns';
import { UserRoleEnum } from '../../pages/AccountManagementPage';
import { format } from 'date-fns-tz';

interface AccountManagementTableProps {
  data: Array<AccountManagementData>;
  loggedInUser: InitialUser;
  onEditButtonClick: (data: AccountManagementData) => void;
  onDeleteButtonClick: (sub: string) => void;
  className?: string;
  testId?: string;
}

const AccountManagementTable: React.FC<AccountManagementTableProps> = ({
  data,
  loggedInUser,
  onEditButtonClick,
  onDeleteButtonClick,
  className,
  testId,
}) => {
  const { t } = useTranslation();

  const headers = [
    t('accountManagement.company'),
    t('accountManagement.accountInfo'),
    t('accountManagement.role'),
    t('accountManagement.lastLogin'),
    t('accountManagement.lastIP'),
    t('accountManagement.createDate'),
    t('accountManagement.management'),
  ];

  return (
    <table data-testid={testId} className={`${className} w-full`}>
      <thead>
        <tr className="h-[36px] rounded-[5px] bg-[#1F384C] text-white">
          {headers.map((value, index) =>
            index === 0 ? (
              <th
                key={index}
                className="noto-12-normal rounded-bl-[5px] rounded-tl-[5px]"
              >
                {value}
              </th>
            ) : index === headers.length - 1 ? (
              <th
                key={index}
                className="noto-12-normal rounded-br-[5px] rounded-tr-[5px]"
              >
                {value}
              </th>
            ) : (
              <th key={index} className="noto-12-normal">
                {value}
              </th>
            )
          )}
        </tr>
      </thead>
      <tbody>
        {data.map((value: AccountManagementData, index) => (
          <tr
            data-testid={`${testId}-item-${index}`}
            key={index}
            className="border-b border-[#E2E7E7]"
          >
            <td
              className="noto-13-normal py-[13px] text-center leading-none text-dark-6"
              key={`${index}-companyName`}
            >
              <span className="noto-14-semibold">{value['companyName']}</span>
              <br />
              <span>{value['department']}</span>
            </td>
            <td
              className="noto-13-normal py-[13px] text-center leading-none text-dark-6"
              key={`${index}-email`}
            >
              {value['email'] ?? '-'}
            </td>
            <td
              className="noto-12-normal w-[60px] py-[13px] text-center leading-none text-white"
              key={`${index}-role`}
            >
              <div
                className={`noto-12-normal flex h-[26px] items-center justify-center rounded-[35px] px-3 ${
                  value.customRole == 2
                    ? 'bg-[#ad4a36]'
                    : value.customRole == 1
                      ? 'bg-[#617DE9]'
                      : 'bg-[#F9AE19]'
                }`}
              >
                {UserRoleEnum[value.customRole] ?? '-'}
              </div>
            </td>
            <td
              className="noto-13-normal py-[13px] text-center leading-none text-dark-6"
              key={`${index}-customLastLoginDate`}
            >
              {value['customLastLoginDate']
                ? format(value['customLastLoginDate'], 'yyyy-MM-dd HH:mm:ss')
                : '-'}
            </td>
            <td
              className="noto-13-normal py-[13px] text-center leading-none text-dark-6"
              key={`${index}-customLastLoginIp`}
            >
              {value['customLastLoginIp'] ?? '-'}
            </td>
            <td
              className="noto-13-normal py-[13px] text-center leading-none text-dark-6"
              key={`${index}-createdDate`}
            >
              {format(value['createdDate'], 'yyyy-MM-dd HH:mm:ss', {
                timeZone: 'Asia/Seoul',
              }) ?? '-'}
            </td>
            {(loggedInUser.customRole !== String(UserRoleEnum.User) ||
              loggedInUser.sub == value['sub']) && (
              <td className="flex justify-center py-[26px]">
                <SVGImage
                  name="edit"
                  onClick={() => onEditButtonClick(value)}
                  className="mr-[14px] cursor-pointer"
                />
                <SVGImage
                  testId={`${testId}-item-${index}-delete`}
                  name="delete"
                  onClick={() => onDeleteButtonClick(value.sub)}
                  className="cursor-pointer"
                />
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AccountManagementTable;
